import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await register(email, password, name); nav('/cuenta'); }
    catch (err) { toast.error(err?.response?.data?.detail || 'No se pudo crear la cuenta'); }
    finally { setLoading(false); }
  };

  return (
    <main className="bg-stilo-bg min-h-[70vh]" data-testid="register-page">
      <div className="max-w-md mx-auto px-6 pt-16 pb-32">
        <p className="overline">Crear cuenta</p>
        <h1 className="font-serif text-5xl mt-4">Empieza tu proyecto.</h1>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="overline">Nombre</label>
            <input required value={name} onChange={e=>setName(e.target.value)} className="mt-2 w-full border-b border-stilo-ink/30 py-2 bg-transparent focus:outline-none focus:border-stilo-ink" data-testid="reg-name" />
          </div>
          <div>
            <label className="overline">Email</label>
            <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-2 w-full border-b border-stilo-ink/30 py-2 bg-transparent focus:outline-none focus:border-stilo-ink" data-testid="reg-email" />
          </div>
          <div>
            <label className="overline">Contraseña</label>
            <input type="password" required minLength={6} value={password} onChange={e=>setPassword(e.target.value)} className="mt-2 w-full border-b border-stilo-ink/30 py-2 bg-transparent focus:outline-none focus:border-stilo-ink" data-testid="reg-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-stilo w-full justify-center" data-testid="reg-submit">{loading ? 'Creando…' : 'Crear cuenta'}</button>
        </form>
        <p className="mt-8 text-sm text-stilo-ink2">¿Ya tienes cuenta? <Link to="/login" className="text-stilo-ink underline">Acceder</Link></p>
      </div>
    </main>
  );
}
